/* eslint-disable class-methods-use-this */
import ContratEntity, {
  ContratWDH,
} from 'utils/__interfaces/Perimeter/ContratEntity'

class ContratNormalizer {
  normalize(contratList: ContratWDH[]): ContratEntity[] {
    return contratList.map((contrat) => {
      const signataire = contrat.fkEtabEntrepriseClientSignataire
      const address = signataire?.adresses?.[0] ?? contrat.adresses?.[0]

      const name =
        signataire?.raisonSociale ??
        signataire?.nom ??
        contrat.raisonSociale ??
        contrat.nom ??
        ''
      const numeroContratSAP =
        contrat.numeroContratSAP ??
        contrat.idFonctionnelContrat ??
        contrat.numClient ??
        ''

      return {
        id: String(contrat.idContrat),
        name,
        siret: signataire?.codeSiret ?? contrat.codeSiret ?? '',
        address: `${address?.rueAdresse ?? ''} ${
          address?.codePostalAdresse ?? ''
        } ${address?.villeAdresse ?? ''}`,
        villeCP: `${address?.codePostalAdresse ?? ''} - ${
          address?.villeAdresse ?? ''
        }`,
        shortAdress: `${address?.rueAdresse ?? ''} `,
        numeroContratSAP,
        numDebiteur: numeroContratSAP,
      }
    })
  }
}

export default new ContratNormalizer()
